import {action, decorate, observable} from 'mobx';
import {uniqueId} from 'lodash';
import {FlashMessage} from '../models/flashMessage';

decorate(FlashMessage, {
  type: observable,
  message: observable,
  title: observable,
});

export class FlashMessageStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.comparator = (id) => (e) => e.id.toString() === id.toString();
  }

  /**
   * @type {FlashMessage[]}
   */
  flashMessages = [];

  /**
   * @param {FlashMessage} message
   */
  addFlashMessage(message) {
    this.flashMessages.push({
      ...message,
      id: uniqueId(),
    });
  }

  removeFlashMessage(message) {
    const index = this.flashMessages.findIndex(this.comparator(message.id));
    if (index >= 0) {
      this.flashMessages.splice(index, 1);
    }
  }

  clear() {
    this.flashMessages.splice(0);
  }
}

decorate(FlashMessageStore, {
  flashMessages: observable,
  addFlashMessage: action,
  removeFlashMessage: action,
});
